export default __webpack_public_path__ + "static/media/1-table-6-chair.a5df7c5d.png";